/**
 * Befüllt die Felder eines Formulars mit den Werten aus den zugehörigen Query Parametern.
 * Aus Caching-Gründen kann es sinnvoll sein, dies clientseitig zu machen.
 *
 * @namespace FormPrefill
 * @aka COMMON.FormPrefill
 */
COMMON.FormPrefill = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'formPrefill';
  var DATA_KEY = 'common.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: 'form[data-prefill]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var FormPrefill = function () {

    function FormPrefill(element) {
      // protected
      this.element = element;
      this.$element = $(this.element);

      console.log("FormPrefill");

      if (this.$element.prop('method').toLowerCase() !== 'get') {
        console.warn('FormPrefill: Formular verwendet nicht die "get" Methode.');
        this.dispose();
        return;
      }

      this.params = COMMON.Utils.parseUrl(window.location.href).paramsAsArray;

      this._applyParams(this.params);
    }

    /**
     * Applies values from URL params to input elements.
     * @param {Array<Array<String>>} params
     * @private
     */
    FormPrefill.prototype._applyParams = function(params) {
      var self = this;

      // iterate over URL params
      for (var name in params) {
        if (params[name].length === 0) {
          continue;
        }

        // Look for input elements whose name match the parameter name (can be more than one, i.e. for checkboxes and radios)
        var $inputElements = this.$element.find('[name="' + name + '"]');
        if ($inputElements.length === 0) {
          continue;
        }

        // Iterate input elements and apply value.
        $inputElements.each(function() {
          var $input = $(this)

          if ($input.is('input[type="checkbox"]')) {
            self._handleCheckbox.call(self, $input, params[name]);

          } else if ($input.is('input[type="radio"]')) {
            self._handleRadio.call(self, $input, params[name]);

          } else if ($input.is('input')) { // checking for all input types AFTER we checked for radio and checkboxes
            self._handleInput.call(self, $input, params[name]);

          } else if ($input.is('textarea')) {
            self._handleTextarea.call(self, $input, params[name]);

          } else if ($input.is('select')) {
            self._handleSelect.call(self, $input, params[name]);
          }
        })
      }
    }

    /**
     * Sets input value to first value of values array.
     * @param $input
     * @param {Array<String>} values
     * @private
     */
    FormPrefill.prototype._handleInput = function($input, values) {
      $input.val(this._decodeQueryParam(values[0]));
    }

    FormPrefill.prototype._handleTextarea = function($textarea, values) {
      $textarea.val(this._decodeQueryParam(values[0]));
    }

    FormPrefill.prototype._handleCheckbox = function($checkbox, values) {
      $checkbox.prop('checked', values.indexOf($checkbox.prop('value')) !== -1);
    }

    FormPrefill.prototype._handleRadio = function($radio, values) {
      $radio.prop('checked', values.indexOf($radio.prop('value')) !== -1);
    }

    FormPrefill.prototype._handleSelect = function ($select, values) {
      $select.val(values);
    }

    FormPrefill.prototype._decodeQueryParam = function (value) {
      return decodeURIComponent(value.replace(/\+/g, '%20'))
    }

    // public
    FormPrefill.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    FormPrefill._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        new FormPrefill(this);
      });
    };

    return FormPrefill;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    FormPrefill._jQueryInterface.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      FormPrefill._jQueryInterface.call($element);
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = FormPrefill._jQueryInterface;
  $.fn[NAME].Constructor = FormPrefill;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return FormPrefill._jQueryInterface;
  };

  return FormPrefill;

})(window.jQuery);
